import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import Color from 'color';

export class Tags extends Field {
  static get disableFieldForModelNames() {
    return ['Release'];
  }

  static subqueriesForModel() {
    return { tags: ['name', 'color'] };
  }

  get title() {
    return 'Tags';
  }

  exampleContents(): FieldContentsData {
    return {
      tags: [
        { name: 'navigation', color: '#5254E0' },
        { name: 'widget', color: '#52BEE0' },
      ],
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.tags?.length) {
      return {
        tags: record.tags.map(({ name, color }) => {
          color = Color(color);

          return {
            name,
            color: color.hex(),
          };
        }),
      };
    }

    return {};
  }
}
